import { Component } from "@angular/core";

@Component({
  selector: "close-icon-svg",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
    <symbol id="closeIcon" viewBox="0 0 16 16" fill="none">
        <path
          d="M12.5 3.5L3.5 12.5"
          stroke="var(--stroke-color, #2d405d)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 12.5L3.5 3.5"
          stroke="var(--stroke-color, #2d405d)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
    </svg>
  `,
})
export class CloseIconSvgComponent {}
